import InPageNavButton from './button';
export default InPageNavButton;
